import { useNavigate } from "react-router-dom";
import { Button } from "@material-tailwind/react";
import { FaTools } from "react-icons/fa";

export default function ComingSoon({ title = "This feature" }) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center flex-grow w-full bg-gradient-to-b from-blue-50 to-white p-6">
      <div className="bg-white shadow-lg rounded-2xl p-10 max-w-md w-full text-center border border-gray-100">
        
        {/* Icon */}
        <div className="text-blue-500 text-6xl flex justify-center mb-6">
          <FaTools />
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold mb-3 text-gray-800">
          {title}
        </h1>

        {/* Subtitle */}
        <p className="text-gray-600 leading-relaxed mb-8">
          We're working hard to bring this feature to you.  
          Please stay tuned — exciting updates are on the way!
        </p>

        {/* Back button */}
        <div className="flex justify-center">
          <Button
            color="blue"
            className="px-6 py-2 rounded-lg shadow-sm"
            onClick={() => navigate("/dashboard")}
          >
            Back to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
